module.exports = __webpack_public_path__ + "img/bg_alternate-login.97d1cf19.svg";